import { useCallback } from "react";

export const useSorter = (
  request: any,
  setRequest: React.Dispatch<React.SetStateAction<any>>
) => {
  const onSortChange = useCallback(
    (_pagination: any, _filter: any, sorter: any) => {
      const newRequest = { ...request };

      const { order } = sorter;

      if (order) {
        newRequest.sort = order === "ascend" ? 1 : 2;
      } else {
        newRequest.sort = 0;
      }

      setRequest(newRequest);
    },
    [request, setRequest]
  );

  return { onSortChange };
};
